import { useTranslation } from "react-i18next";
import slideImage from "@/assets/onboarding-slide-4.webp";

export function OnboardingSlideThree() {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center h-full px-6 pb-32 relative overflow-hidden">
      {/* Animated background blobs */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div 
          className="absolute top-24 right-0 w-60 h-60 rounded-full animate-pulse-glow"
          style={{
            background: 'radial-gradient(circle, hsl(var(--primary) / 0.15) 0%, transparent 70%)',
            filter: 'blur(45px)',
          }}
        />
        <div 
          className="absolute top-1/2 -left-20 w-56 h-56 rounded-full animate-pulse-glow"
          style={{
            background: 'radial-gradient(circle, hsl(var(--accent) / 0.12) 0%, transparent 70%)',
            filter: 'blur(40px)',
            animationDelay: '1.2s',
          }}
        />
        <div 
          className="absolute bottom-48 right-1/4 w-44 h-44 rounded-full animate-pulse-glow"
          style={{
            background: 'radial-gradient(circle, hsl(var(--primary) / 0.1) 0%, transparent 70%)',
            filter: 'blur(35px)',
            animationDelay: '0.6s',
          }}
        />
      </div>

      {/* Image container with glass effect */}
      <div className="flex items-center justify-center w-full mb-8 relative z-10">
        <div 
          className="rounded-3xl p-2"
          style={{
            background: 'linear-gradient(135deg, hsl(var(--card) / 0.4), hsl(var(--card) / 0.1))',
            backdropFilter: 'blur(10px)',
          }}
        >
          <img
            src={slideImage}
            alt="Budget transparency"
            width={320}
            height={427}
            className="w-80 h-auto rounded-2xl"
            loading="lazy"
          />
        </div>
      </div>

      {/* Text content with glass card */}
      <div 
        className="text-center w-full max-w-xs relative z-10 px-5 py-4 rounded-2xl"
        style={{
          background: 'linear-gradient(135deg, hsl(var(--card) / 0.7), hsl(var(--card) / 0.4))',
          backdropFilter: 'blur(24px) saturate(180%)',
          border: '1px solid hsl(var(--border) / 0.3)',
          boxShadow: '0 8px 32px hsl(var(--primary) / 0.1)',
        }}
      >
        <h1 className="text-xl font-bold text-foreground mb-3 leading-snug">
          {t("onboarding.transparency.title")}
        </h1>
        <p className="text-muted-foreground text-base leading-relaxed">
          {t("onboarding.transparency.subtitle")}
        </p>
      </div>
    </div>
  );
}
